/**
 * Collection page helpers
 */
window.quickAdd = function(handle) {
  // Check for a cached modal for this handle
  var cached = document.querySelector('[data-quick-add-modal][data-wqa-handle="' + handle + '"]');
  if (cached) {
    openQuickAddModal(cached);
    return;
  }

  // Build the dialog shell — mirrors product-quick-add-modal-template.liquid
  var dialog = document.createElement('dialog');
  dialog.className = 'drawer product-quick-add';
  dialog.setAttribute('data-quick-add-modal', '');
  dialog.setAttribute('data-wqa-handle', handle);
  dialog.setAttribute('data-scroll-lock-required', '');
  dialog.setAttribute('inert', '');
  dialog.innerHTML = [
    '<form method="dialog"><button class="visually-hidden no-js" aria-label="Close"></button></form>',
    '<div class="drawer__inner product-quick-add__content" data-product-upsell-container data-scroll-lock-scrollable style="--swatch-size: var(--swatch-size-product)">',
      '<div class="product-quick-add__close-outer">',
        '<button class="product-quick-add__close drawer__close" aria-label="Close" data-quick-add-modal-close autofocus>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 1L17 17M1 17L17 1" stroke="currentColor" stroke-width="1.5"/></svg>',
        '</button>',
      '</div>',
      '<div class="product-quick-add__inner" data-product-upsell-ajax></div>',
      '<div class="loader loader--top"><div class="loader-indeterminate"></div></div>',
    '</div>'
  ].join('');

  document.body.appendChild(dialog);

  // Fetch the section content and inject it
  fetch(window.theme.routes.root + 'products/' + handle + '?section_id=api-product-upsell')
    .then(function(r) {
      if (!r.ok) throw new Error('quickAdd fetch failed: ' + r.statusText);
      return r.text();
    })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('[data-api-content]');
      var target = dialog.querySelector('[data-product-upsell-ajax]');
      if (content && target) {
        target.innerHTML = content.innerHTML;
      }
      openQuickAddModal(dialog);
    })
    .catch(function(err) {
      console.error(err);
      dialog.remove();
    });
};

function openQuickAddModal(modal) {
  // Close any other open quick-add modals first
  document.querySelectorAll('[data-quick-add-modal][open]').forEach(function(m) {
    m.dispatchEvent(new CustomEvent('theme:modal:close', { bubbles: false }));
  });

  if (typeof modal.show === 'function') {
    modal.show();
  }
  modal.setAttribute('open', true);
  modal.removeAttribute('inert');

  // Animate items inside
  requestAnimationFrame(function() {
    modal.querySelectorAll('[data-animation]').forEach(function(el) {
      el.classList.add('is-animated');
    });
  });

  document.dispatchEvent(new CustomEvent('theme:quick-add:open', { bubbles: true }));
  document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));

  // Wire up close button
  var closeBtn = modal.querySelector('[data-quick-add-modal-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() { closeQuickAddModal(modal); }, { once: true });
  }

  // Close on backdrop click
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeQuickAddModal(modal);
  });

  // Close on ESC
  function onKeydown(e) {
    if (e.code === 'Escape') {
      e.preventDefault();
      closeQuickAddModal(modal);
      document.removeEventListener('keydown', onKeydown);
    }
  }
  document.addEventListener('keydown', onKeydown);

  // Auto-close after product is added
  document.addEventListener('theme:product:added', function() { closeQuickAddModal(modal); }, { once: true });
}

function closeQuickAddModal(modal) {
  modal.removeAttribute('open');
  modal.setAttribute('inert', '');
  modal.querySelectorAll('[data-animation]').forEach(function(el) { el.classList.remove('is-animated'); });
  document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  if (typeof modal.close === 'function') modal.close();
}
